import { render, staticRenderFns } from "./Packscontratados.vue?vue&type=template&id=2e0a6ea1"
import script from "./Packscontratados.vue?vue&type=script&lang=js"
export * from "./Packscontratados.vue?vue&type=script&lang=js"
import style0 from "./Packscontratados.vue?vue&type=style&index=0&id=2e0a6ea1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports